import React, { Component, Fragment } from "react";
import { observer } from "mobx-react";
import { Form, Drawer, Select, InputNumber, Button, Checkbox } from "antd";

const FormItem = Form.Item;
const Option = Select.Option;

@Form.create({})
@observer
export default class ArticleBuilderDrawer extends Component {
	constructor(props) {
		super(props);
	}

	downloadArticle = () => {
		this.props.form.validateFieldsAndScroll((err, vals) => {
			if (err != null) {
				return;
			}
			this.props.downloadArticleBuilderArticle({
				articleSource: "ArticleBuilder",
				inputInfo: JSON.stringify({
					categoryId: vals.category,
					wordCount: vals.wordCount,
					spinArticle: vals.spinArticle
				})
			});
		});
	};

	render() {
		const {
			ui: { articleBuilderDrawerVisible, downloadingArticleBuilderArticle }
		} = this.props;

		return (
			<Drawer
				title="Download Article Builder Article"
				placement="top"
				closable={false}
				onClose={this.props.hideDrawer}
				visible={articleBuilderDrawerVisible}
				height={390}
			>
				<Form>
					<FormItem label="Category" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator("category", {
							rules: [
								{
									required: true,
									message: "You need to select a category"
								}
							]
						})(
							<Select showSearch style={{ width: 200 }}>
								{this.props.articleBuilderCategories.map(category => {
									return (
										<Option key={category.value} value={category.value}>
											{category.name}
										</Option>
									);
								})}
							</Select>
						)}
					</FormItem>
					<FormItem label="Word Count" style={{ marginBottom: 10 }}>
						{this.props.form.getFieldDecorator("wordCount", {
							rules: [
								{
									required: true,
									type: "integer",
									min: 300,
									max: 1000,
									message:
										"Word count is required and in the range of 300 to 1000"
								}
							]
						})(<InputNumber />)}
					</FormItem>
					<FormItem>
						{this.props.form.getFieldDecorator(`spinArticle`, {
							valuePropName: "checked"
						})(<Checkbox>Also spin the article</Checkbox>)}
					</FormItem>
					<div
						style={{
							position: "absolute",
							bottom: 0,
							width: "100%",
							borderTop: "1px solid #e8e8e8",
							padding: "10px 16px",
							textAlign: "left",
							left: 0,
							background: "#fff",
							borderRadius: "0 0 4px 4px"
						}}
					>
						<Button
							style={{
								marginRight: 8
							}}
							onClick={this.props.hideDrawer}
						>
							Cancel
						</Button>
						<Button
							type="primary"
							onClick={this.downloadArticle}
							loading={downloadingArticleBuilderArticle}
						>
							Save
						</Button>
					</div>
				</Form>
			</Drawer>
		);
	}
}
